import { connectInternalApi } from 'common/api'
import { TreeNode } from 'common/components/catalog/Catalog'

export interface PersonalizationResponse {
  _id: string
  name: string
  useCase: string
  channels: string[]
  status: string
  startDate: string
  endDate: string
  optimisationId: string
  accountId: string
  control: { id: string; text: string }
  trainingContent?: 'contextual' | 'personalized'
}

type FilterItem = {
  displayName: string
  value: string
}

type FiltersResponse = {
  useCases: FilterItem[]
  productCategories: TreeNode
  channels: FilterItem[]
}

type GraphsResponse = { displayName: string; value: number }[]

type Variant = {
  variantText: string
  channel: string
  clicks: number
  sends: number
  opens: number
}

type VariantsResponse = {
  filteredCount: number
  items: Variant[]
  totalCount: number
}

type DateAttribute = {
  name: string
  type: 'date'
  startDate: string
  endDate: string
}

type NumberAttribute = {
  name: string
  type: 'number'
  min: number
  max: number
}

type ListAttribute = {
  name: string
  type: 'list'
  values: string[]
}

export type CustomerAttributeResponse = (
  | DateAttribute
  | NumberAttribute
  | ListAttribute
)[]

export async function fetchActivePersonalizedCampaigns(accountId: string) {
  const result = await connectInternalApi.get<PersonalizationResponse[]>(
    `v1/accounts/${accountId}/personalization`
  )

  return result.data
}

export const fetchFilters = async (accountId: string) => {
  const result = await connectInternalApi.get<FiltersResponse>(
    `v1/accounts/${accountId}/personalization/filters`
  )

  return result.data
}

export const fetchGraphs = async ({
  accountId,
  channelId,
  personalizationId,
}: {
  accountId: string
  channelId?: string
  personalizationId: string
}) => {
  const result = await connectInternalApi.get<GraphsResponse>(
    `v1/accounts/${accountId}/personalization/${personalizationId}/metrics`,
    {
      params: {
        channel: channelId,
      },
    }
  )

  return result.data
}

export const fetchVariants = async ({
  accountId,
  personalizationId,
}: {
  accountId: string
  personalizationId: string
}) => {
  const result = await connectInternalApi.get<VariantsResponse>(
    `v1/accounts/${accountId}/personalization/${personalizationId}/variants`
  )

  return result.data
}

export const fetchCustomerAttributes = async (accountId) => {
  return Promise.resolve<CustomerAttributeResponse>([
    {
      name: 'first purchase',
      type: 'date',
      startDate: '2023-10-01T14:48:00.000Z',
      endDate: '2023-10-15T14:48:00.000Z',
    },
    {
      name: 'second purchase',
      type: 'date',
      startDate: '2023-09-01T14:48:00.000Z',
      endDate: '2023-10-15T14:48:00.000Z',
    },
    {
      name: 'first purchase qty',
      type: 'number',
      min: 0,
      max: 10,
    },
    {
      name: 'second purchase qty',
      type: 'number',
      min: 20,
      max: 60,
    },
    {
      name: 'product name',
      type: 'list',
      values: ['string1', 'string2', 'string3', 'string4', 'string5'],
    },
  ])
}
